import { render, staticRenderFns } from "./reportsCard.vue?vue&type=template&id=b2d83d44&scoped=true"
import script from "./reportsCard.vue?vue&type=script&lang=js"
export * from "./reportsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d83d44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2d83d44')) {
      api.createRecord('b2d83d44', component.options)
    } else {
      api.reload('b2d83d44', component.options)
    }
    module.hot.accept("./reportsCard.vue?vue&type=template&id=b2d83d44&scoped=true", function () {
      api.rerender('b2d83d44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/customer/reportsCard.vue"
export default component.exports